export enum AnalysisPanelTabs {
    FeedbackTab = 'feedback',
    CitationTab = 'citation',
}
